/* tslint:disable */
/* eslint-disable */
/**
 * GlassHouse.Dashboard.Api | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { EnrollmentCalendarItem } from './EnrollmentCalendarItem';
import {
    EnrollmentCalendarItemFromJSON,
    EnrollmentCalendarItemFromJSONTyped,
    EnrollmentCalendarItemToJSON,
    EnrollmentCalendarItemToJSONTyped,
} from './EnrollmentCalendarItem';

/**
 * 
 * @export
 * @interface EnrollmentsCalendarWidgetData
 */
export interface EnrollmentsCalendarWidgetData {
    /**
     * 
     * @type {Array<EnrollmentCalendarItem>}
     * @memberof EnrollmentsCalendarWidgetData
     */
    items: Array<EnrollmentCalendarItem>;
}

/**
 * Check if a given object implements the EnrollmentsCalendarWidgetData interface.
 */
export function instanceOfEnrollmentsCalendarWidgetData(value: object): value is EnrollmentsCalendarWidgetData {
    if (!('items' in value) || value['items'] === undefined) return false;
    return true;
}

export function EnrollmentsCalendarWidgetDataFromJSON(json: any): EnrollmentsCalendarWidgetData {
    return EnrollmentsCalendarWidgetDataFromJSONTyped(json, false);
}

export function EnrollmentsCalendarWidgetDataFromJSONTyped(json: any, ignoreDiscriminator: boolean): EnrollmentsCalendarWidgetData {
    if (json == null) {
        return json;
    }
    return {
        
        'items': ((json['items'] as Array<any>).map(EnrollmentCalendarItemFromJSON)),
    };
}

export function EnrollmentsCalendarWidgetDataToJSON(json: any): EnrollmentsCalendarWidgetData {
    return EnrollmentsCalendarWidgetDataToJSONTyped(json, false);
}

export function EnrollmentsCalendarWidgetDataToJSONTyped(value?: EnrollmentsCalendarWidgetData | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'items': ((value['items'] as Array<any>).map(EnrollmentCalendarItemToJSON)),
    };
}

